import React, { Component } from 'react'
// import logo from './logo.svg';
import './customStyle.scss';
import 'boxicons/css/boxicons.min.css'
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Layout from './Components/Layout';
import Intake from './Pages/Intake';
import PlanSelect from './Pages/PlanSelect';
import Application from './Pages/Application';
import Completed from './Pages/Completed';
import NotFound from './Pages/NotFound';

export default class App extends Component {

    render() {
        return (
            <BrowserRouter>
                <Routes>
                    <Route path='/' element={<Layout />}>
                        <Route index element={<Intake />} />
                        <Route path='/PlanSelect' element={<PlanSelect />} />
                        <Route path='/Application' element={<Application />} />
                        <Route path='/Completed' element={<Completed />} />
                        <Route path='*' element={<NotFound />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        )
    }
}
